export const daysOfWeek = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const EXCEL_DATE_OFFSET = new Date("1899-12-30T00:00:00Z").getTime();
